import { dataMember, required, typedArray } from 'santee-dcts';

export class AdminEQueryEscalationResponse {
    @dataMember()
    @required()
    @typedArray(String)
    public errors: string[];
}
